module.exports = __webpack_public_path__ + "static/media/bg-2.2121d24c.jpg";